import {z} from 'zod';
import {UpdateSettingRequest} from '../api/generated/index.defs.ts';

export const settingSchema = z.object({
  value: z.string(),
}) satisfies z.Schema<UpdateSettingRequest>;
export type SettingSchema = z.TypeOf<typeof settingSchema>;